import React, { useContext } from "react";
import TRow from "./TRow";

import AllContext from "../../AllContext";

const TBody = () => {
  const { data } = useContext(AllContext);

  return (
    <>
      {data.map((doc, i) => (
        <TRow data={data} doc={doc} key={doc.id || i} />
      ))}
    </>
  );
};

export default TBody;
